<template>
  <div style="margin-top:15px">
    <el-form ref="form" :rules="rules" :model="formData" label-width="80px">
      <el-row>
        <el-form-item label="编码" prop="code" style="margin-right:15px">
          <el-input v-model.trim="formData.code" :placeholder="codeTips" />
        </el-form-item>
        <el-form-item label="名称" prop="name" style="margin-right:15px">
          <el-input v-model.trim="formData.name" placeholder="请输入名称" @change="(value)=>{formData.groupName = value.replace(/\s/g,'')}" />
        </el-form-item>
        <el-form-item label="状态" prop="status" style="margin-right:15px">
          <el-select v-model="formData.status">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark" style="margin-right:15px">
          <el-input v-model="formData.remark" placeholder="请输入备注" />
        </el-form-item>
        <el-form-item label="排序" prop="sort" style="margin-right:15px">
          <el-input v-model="formData.sort" placeholder="请输入排序" @input="(value)=>formFormatter.isInteger(value,oldValue,formData,'sort')" />
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'DictAdd',
  data() {
    return {
      codeTips: '请输入编码',
      formData: {
        type: '',
        code: '',
        name: '',
        status: 0,
        remark: '',
        sort: 0
      },
      // 状态
      statusList: [
        { label: '正常', value: 0 },
        { label: '停用', value: 1 }
      ],
      rules: {
        code: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          { max: 100, message: "长度为100个字符"}
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { max: 255, message: "长度为255个字符"}
        ],
        // sort: [
        //   { required: false, type: 'number',max:1000000000, message: '排序必须为小于1000000000的数字值' }
        // ],
        remark: [
          { max: 255, message: "长度为255个字符"}
        ]
      }
    }
  },
  created() {},
  methods: {
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const data = this.formData
          const rLoading = this.openLoading();
          request({ url: '/ntocc-basic-api/dict', method: 'post', params: data }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherAddMethod')
          }).then(() => this.$refs['form'].resetFields())
        } else {
          return false
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'add')
    }
  }
}
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin:15px 0 15px 0;
        width: 175px;
        float: right;
    }
</style>
